import Auth from '../auth/Auth.js'

export default {
  install (app) {
    app.config.globalProperties.$auth = Auth
  }
}
